import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { AlertCircle } from "lucide-react";

export interface InputFieldProps {
  id: string;
  label: string;
  error?: string;
  placeholder?: string;
  type?: string;
  textarea?: boolean;
  defaultValue?: string;
}

export function InputField({ id, label, error, placeholder, type = "text", textarea, defaultValue }: InputFieldProps) {
  return (
    <div className="space-y-1.5 text-left">
      <Label htmlFor={id} className="text-xs font-bold text-muted-foreground uppercase tracking-wider">
        {label}
      </Label>
      {textarea ? (
        <Textarea id={id} name={id} defaultValue={defaultValue} className="border-border/40 hover:border-brand-primary/30 transition-all duration-300 rounded-xl min-h-[120px] resize-y" placeholder={placeholder} />
      ) : (
        <Input id={id} name={id} type={type} defaultValue={defaultValue} className="border-border/40 hover:border-brand-primary/30 transition-all duration-300 rounded-xl" placeholder={placeholder} />
      )}
      {error && (
        <p className="text-xs font-bold text-destructive flex items-center gap-1">
          <AlertCircle className="h-3.5 w-3.5 shrink-0" />
          <span>{error}</span>
        </p>
      )}
    </div>
  );
}

export default InputField;
